const getProductType =(productType) => {
    switch(productType){
      case 'TERM':
        return "Term Life Insurance";
      case 'PERM':
        return "Permanent Life Insurance";
      case 'LTC':
        return "Long Term Care";
      default :
       return productType;      
    }
  }

  export default getProductType;


// WEBPACK FOOTER //
// ./src/components/Notifications/SubComponents/ProductType.js